/* Werwulf landing (page.werwulf): hero scroll scene, text reveals, parallax, chapter nav,
   slider and add to cart. */
(() => {
  const root = document.querySelector('[data-werwulf]');
  if (!root) return;

  const gsap = window.gsap;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const SMOOTHING = reduced ? 1 : 0.07;
  const cl = (x) => (x < 0 ? 0 : x > 1 ? 1 : x);
  const sm = (x, a, b) => {
    const t = cl((x - a) / (b - a));
    return t * t * (3 - 2 * t);
  };
  const q = (s, scope = root) => Array.from(scope.querySelectorAll(s));

  /* Split text into lines (at <br>) or words */

  const splitLines = (el) => {
    const parts = el.innerHTML.split(/<br[^>]*>/i).map((p) => p.trim()).filter(Boolean);
    el.innerHTML = '';
    parts.forEach((html) => {
      const span = document.createElement('span');
      span.className = 'ww-line';
      span.innerHTML = html;
      el.appendChild(span);
    });
  };

  const splitWords = (el, attr) => {
    const walk = (node) => {
      Array.from(node.childNodes).forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          const frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach((token) => {
            if (!token) return;
            if (/^\s+$/.test(token)) {
              frag.appendChild(document.createTextNode(' '));
              return;
            }
            const span = document.createElement('span');
            span.className = 'ww-word';
            span.textContent = token;
            span.setAttribute(attr, '');
            frag.appendChild(span);
          });
          child.replaceWith(frag);
        } else if (child.nodeType === Node.ELEMENT_NODE && child.tagName !== 'BR') {
          walk(child);
        }
      });
    };
    walk(el);
  };

  // Hero text and headlines fog in word by word; other text rises as one block.
  q('[data-ww-split]').forEach((el) => {
    const fog = el.closest('[data-ww-hero]') || el.hasAttribute('data-ww-headline');
    const slide = el.closest('[data-slide]');
    if (fog) {
      if (el.dataset.wwSplit === 'lines') splitLines(el);
      splitWords(el, 'data-ww-fogw');
    } else el.setAttribute(slide && slide.dataset.slide !== '0' ? 'data-l' : 'data-r', '');
  });

  /* Reveals. Durations and delays here, start/end states in CSS.
     - Fog (headlines): each word clears from a 10px blur and a 0.18em drop after a random delay,
       so the words surface in no fixed order.
     - Rise (everything else): comes up 90px (large images 180px) and fades in, in reading order.
     The hero keeps its slow timing; below it everything is quicker, so text is fully in before
     it can be scrolled past. */

  const HERO = { fog: 1.9, fogSpread: 1.7, rise: 1.5, riseFar: 2.2, stagger: 1.2 };
  const PAGE = { fog: 1, fogSpread: 0.4, rise: 0.9, riseFar: 1.3, stagger: 0.4 };
  const EASE = 'cubic-bezier(.2,0,0,1)';
  const fogIn = (els, delay = 0, t = HERO) =>
    els.forEach((el) => {
      el.style.transition = reduced ? 'opacity .8s ease' : `opacity ${t.fog}s ${EASE}, filter ${t.fog}s ${EASE}, transform ${t.fog}s ${EASE}`;
      el.style.transitionDelay = reduced ? '0s' : `${(delay + Math.random() * t.fogSpread).toFixed(2)}s`;
      el.classList.remove('is-out');
      el.classList.add('is-in');
    });
  const fogOut = (els) =>
    els.forEach((el, i) => {
      el.style.transition = reduced ? 'opacity .01s' : 'opacity .7s ease-in, filter .7s ease-in, transform .7s ease-in';
      el.style.transitionDelay = reduced ? '0s' : `${(i * 0.04).toFixed(2)}s`;
      el.classList.remove('is-in');
      el.classList.add('is-out');
    });
  const riseIn = (els, delay = 0, t = HERO) => {
    const step = Math.min(0.2, t.stagger / Math.max(1, els.length));
    els.forEach((el, i) => {
      const d = el.dataset.wwRise === 'far' ? t.riseFar : t.rise;
      el.style.transition = reduced ? 'opacity .6s ease' : `opacity ${d}s ${EASE}, transform ${d}s ${EASE}`;
      el.style.transitionDelay = reduced ? '0s' : `${(delay + i * step).toFixed(2)}s`;
      el.classList.add('is-in');
    });
  };
  // Fade out in place, then drop back to the start position once invisible.
  const riseOut = (els) =>
    els.forEach((el) => {
      el.style.transition = 'opacity .5s ease-in, transform 0s linear .5s';
      el.style.transitionDelay = '0s';
      el.classList.remove('is-in');
    });

  // A swipe row (the mobile scent cards) rises as one block: the row clips its cards, so the ones
  // off to the side would never scroll into view and rising cards would be cut off.
  q('[data-ww-swipe]').forEach((row) => {
    if (row.scrollWidth <= row.clientWidth + 1) return;
    q('[data-r]', row).forEach((el) => el.removeAttribute('data-r'));
    row.setAttribute('data-r', '');
  });

  // Below the hero: every reveal unit rises in as it comes into view. Text starts a little before
  // it appears (the observer looks 10% of the screen past the bottom edge), headlines as they
  // reach the edge so their fog stays visible.
  const REVEAL_AREA = { rootMargin: '0px 0px 10% 0px', threshold: 0 };
  const HEADLINE_AREA = { rootMargin: '0px', threshold: 0 };
  const rises = q('[data-r]').filter((el) => !el.closest('[data-ww-hero]'));
  rises.forEach((el) => {
    const image = el.matches('img, picture') || el.querySelector('img');
    el.removeAttribute('data-r');
    el.setAttribute('data-ww-rise', image && el.getBoundingClientRect().height > 240 ? 'far' : '');
  });
  let batch = [];
  let timer = 0;
  const flush = () => {
    const els = batch.sort((a, b) => {
      const ra = a.getBoundingClientRect();
      const rb = b.getBoundingClientRect();
      return ra.top - rb.top || ra.left - rb.left;
    });
    batch = [];
    timer = 0;
    riseIn(els, 0, PAGE);
  };
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        batch.push(entry.target);
      });
      if (batch.length && !timer) timer = setTimeout(flush, 40);
    },
    REVEAL_AREA
  );
  rises.forEach((el) => io.observe(el));

  // Headlines below the hero come out of the fog when they scroll into view.
  const headlineIO = new IntersectionObserver(
    (entries) =>
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        headlineIO.unobserve(entry.target);
        fogIn(q('[data-ww-fogw]', entry.target), 0, PAGE);
      }),
    HEADLINE_AREA
  );
  q('[data-ww-headline]').forEach((el) => headlineIO.observe(el));

  /* Slider (GSAP) */

  const DUR = reduced ? 0.01 : 1.2;
  const hide = (els) => gsap.set(els, { opacity: 0, y: 24 });
  const reveal = (els, { delay = 0, stagger } = {}) => {
    if (!els.length) return;
    const st = reduced ? 0 : stagger ?? Math.min(0.15, 1.2 / Math.max(1, els.length));
    gsap.to(els, { opacity: 1, y: 0, duration: DUR, ease: 'power2.out', stagger: st, delay, overwrite: 'auto' });
  };
  if (gsap) hide(q('[data-l]'));

  /* Hero: pinned forest scene with parallax layers, fog, three text scenes and scroll snap */

  const hero = root.querySelector('[data-ww-hero]');
  const H = {
    back: hero.querySelector('[data-ww-layer="back"]'),
    front: hero.querySelector('[data-ww-layer="front"]'),
    darken: hero.querySelector('[data-ww-darken]'),
    center: hero.querySelector('[data-ww-center]'),
    cue: hero.querySelector('[data-ww-cue]'),
    fog1: hero.querySelector('[data-ww-fog-layer="1"]'),
    fog2: hero.querySelector('[data-ww-fog-layer="2"]'),
  };

  // Scenes: lockup, "Here Beginneth The Work", the three witnesses. The current scene's words go
  // back into the fog, the next scene's words come out of it and its buttons rise in.
  const scenes = q('[data-ww-scene]', hero).sort((a, b) => a.dataset.wwScene - b.dataset.wwScene);
  let scene = -1;
  const setScene = (n) => {
    if (n === scene) return;
    const prev = scenes[scene];
    const next = scenes[n];
    scene = n;
    if (prev) {
      prev.classList.remove('is-active');
      fogOut(q('[data-ww-fogw]', prev));
      riseOut(q('[data-ww-rise]', prev));
    }
    next.classList.add('is-active');
    const delay = prev ? 0.45 : 0;
    fogIn(q('[data-ww-fogw]', next), delay);
    riseIn(q('[data-ww-rise]', next), delay + 0.6);
  };

  // Scroll snap: inside the hero, one wheel tick, swipe or key glides 1.2s to the next stop
  // (0, 28%, 62%, then out to Chapter I), and further input is ignored for 1.9s.
  let lockUntil = 0;
  let snapRaf = 0;
  const stops = () => {
    const top = hero.getBoundingClientRect().top + window.scrollY;
    const max = Math.max(1, hero.offsetHeight - window.innerHeight);
    return [0, top + max * 0.28, top + max * 0.62, top + hero.offsetHeight - headerOffset()];
  };
  const inHero = (dir) => {
    const s = stops();
    const end = s[s.length - 1];
    return window.scrollY < end - 2 || (dir < 0 && window.scrollY <= end + 2);
  };
  const scrollTween = (to) => {
    const from = window.scrollY;
    const dur = reduced ? 1 : 1200;
    const t0 = performance.now();
    lockUntil = t0 + (reduced ? 300 : 1900);
    cancelAnimationFrame(snapRaf);
    const run = (now) => {
      const x = Math.min(1, (now - t0) / dur);
      const e = x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
      window.scrollTo(0, from + (to - from) * e);
      if (x < 1) snapRaf = requestAnimationFrame(run);
    };
    snapRaf = requestAnimationFrame(run);
  };
  const step = (dir) => {
    if (performance.now() < lockUntil) return;
    const s = stops();
    const y = window.scrollY;
    let idx = 0;
    let best = Infinity;
    s.forEach((v, i) => {
      const d = Math.abs(v - y);
      if (d < best) {
        best = d;
        idx = i;
      }
    });
    if (best > 40) idx = dir > 0 ? s.findIndex((v) => v > y) - 1 : s.findIndex((v) => v >= y);
    scrollTween(s[Math.max(0, Math.min(s.length - 1, idx + dir))]);
  };
  // Only input on the page itself; the theme's menu and cart drawers keep scrolling normally.
  const onPage = (e) => root.contains(e.target) || e.target === document.body || e.target === document.documentElement;

  window.addEventListener(
    'wheel',
    (e) => {
      const dir = Math.sign(e.deltaY);
      if (!dir || e.ctrlKey || !onPage(e) || !inHero(dir)) return;
      e.preventDefault();
      if (performance.now() < lockUntil || Math.abs(e.deltaY) < 10) return;
      step(dir);
    },
    { passive: false }
  );
  let touchY = null;
  window.addEventListener('touchstart', (e) => (touchY = e.touches[0].clientY), { passive: true });
  window.addEventListener(
    'touchmove',
    (e) => {
      if (touchY == null || !onPage(e)) return;
      const dy = touchY - e.touches[0].clientY;
      const dir = Math.sign(dy);
      if (!dir || !inHero(dir)) return;
      e.preventDefault();
      if (Math.abs(dy) > 30) {
        step(dir);
        touchY = null;
      }
    },
    { passive: false }
  );
  window.addEventListener('keydown', (e) => {
    const dir = { ArrowDown: 1, PageDown: 1, ' ': 1, ArrowUp: -1, PageUp: -1 }[e.key];
    if (!dir || !inHero(dir)) return;
    if (/INPUT|TEXTAREA|SELECT|BUTTON/.test(e.target.tagName) || e.target.isContentEditable) return;
    e.preventDefault();
    step(dir);
  });
  const enter = hero.querySelector('[data-ww-enter]');
  if (enter) {
    enter.addEventListener('click', (e) => {
      e.preventDefault();
      lockUntil = 0;
      scrollTween(stops()[1]);
    });
  }

  const FOG_BASE = 0.14;
  const start = performance.now();
  let current = -1;

  const updateHero = (now, vw, vh) => {
    const rect = hero.getBoundingClientRect();
    if (rect.bottom < -vh || rect.top > vh) return;
    const target = cl(-rect.top / Math.max(1, rect.height - vh));
    // First frame starts where the page is (e.g. reload mid-scroll) instead of easing from the top.
    if (current < 0) current = target;
    current += (target - current) * SMOOTHING;
    if (Math.abs(target - current) < 0.0001) current = target;
    const p = current;
    const t = reduced ? 0 : (now - start) / 1000;

    const backRoom = Math.max(0, H.back.offsetHeight - vh);
    const frontRoom = Math.max(0, H.front.offsetHeight - vh);
    H.front.style.transform = `translate3d(-50%, ${-p * frontRoom}px, 0)`;
    H.back.style.transform = `translate3d(-50%, ${-p * Math.min(backRoom, frontRoom * 0.3)}px, 0)`;

    H.center.style.transform = `translate3d(0, ${-sm(p, 0, 0.6) * 4}vh, 0)`;
    setScene(target < 0.1 ? 0 : target < 0.45 ? 1 : 2);

    const cp = Math.min(1, p / 0.06);
    H.cue.style.opacity = 1 - cp;
    H.cue.style.transform = `translate3d(0, ${cp * 10}px, 0)`;
    H.cue.style.visibility = cp >= 1 ? 'hidden' : 'visible';

    H.darken.style.opacity = (sm(p, 0.55, 0.85) * 0.5 + sm(p, 0.9, 1) * 0.5).toFixed(3);

    const fog1x = Math.sin(t * 0.045) * 18 + p * 20;
    const fog1y = Math.cos(t * 0.06) * 4 - p * 70;
    const fog2x = -Math.sin(t * 0.032 + 1) * 22 - p * 30;
    const fog2y = Math.sin(t * 0.04) * 5 - p * 90;
    H.fog1.style.transform = `translate3d(${(fog1x * vw) / 100}px, ${(fog1y * vh) / 100}px, 0) scale(${1.1 + p * 1.4})`;
    H.fog2.style.transform = `translate3d(${(fog2x * vw) / 100}px, ${(fog2y * vh) / 100}px, 0) scale(${1 + p * 1.8})`;
    H.fog1.style.opacity = (FOG_BASE * (0.75 + 0.25 * Math.sin(t * 0.21)) * (1 + p * 0.6)).toFixed(3);
    H.fog2.style.opacity = (FOG_BASE * 0.8 * (0.7 + 0.3 * Math.sin(t * 0.13 + 2)) * (1 + p * 0.8)).toFixed(3);
  };

  /* Parallax on full-bleed images, tied directly to the scroll position so they stop with it */

  const pars = reduced ? [] : q('[data-ww-par]');
  const updateParallax = (vh) => {
    pars.forEach((el) => {
      const box = el.parentElement.getBoundingClientRect();
      if (box.bottom < -vh * 0.5 || box.top > vh * 1.5) return;
      const limit = box.height * 0.075;
      const raw = -(box.top + box.height / 2 - vh / 2) * parseFloat(el.dataset.wwPar);
      const y = Math.max(-limit, Math.min(limit, raw)).toFixed(1);
      if (el.__y === y) return;
      el.__y = y;
      el.style.transform = `translate3d(0, ${y}px, 0)`;
    });
  };

  /* Chapter nav: one bar, sticky in CSS. Here: the header height it sticks under, the stuck
     state (for its backdrop) and the current chapter */

  const nav = root.querySelector('[data-ww-chapnav]');
  const navLinks = nav ? q('a[data-ch]', nav) : [];
  const chapters = q('[data-chapter]');
  let navStuck = false;
  let activeCh = -1;
  let headerBottom = -1;
  const siteHeader = document.querySelector('#header');
  const headerOffset = () => (siteHeader ? Math.max(0, Math.round(siteHeader.getBoundingClientRect().bottom)) : 0);

  const updateNav = (vh) => {
    if (!nav) return;
    const bottom = headerOffset();
    if (bottom !== headerBottom) {
      headerBottom = bottom;
      root.style.setProperty('--ww-header-h', `${bottom}px`);
    }
    const stuck = nav.getBoundingClientRect().top <= bottom + 1;
    if (stuck !== navStuck) {
      navStuck = stuck;
      nav.classList.toggle('is-stuck', stuck);
    }
    let ch = 1;
    chapters.forEach((sec) => {
      if (sec.getBoundingClientRect().top < vh * 0.5) ch = +sec.dataset.chapter;
    });
    if (ch !== activeCh) {
      activeCh = ch;
      navLinks.forEach((a) => {
        const on = +a.dataset.ch === ch;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }
  };

  const tick = (now) => {
    // `shopify theme dev` hot reload (and the theme editor) swap the section HTML in place without
    // re-running this script, which leaves every scene visible at once. Reload instead.
    if (!root.isConnected) {
      window.location.reload();
      return;
    }
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    updateHero(now, vw, vh);
    updateParallax(vh);
    updateNav(vh);
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);

  /* "I • The Wode" slider */

  const slider = root.querySelector('[data-ww-slider]');
  const dots = root.querySelector('[data-ww-dots]');
  if (slider && dots) {
    const slides = q('[data-slide]', slider);
    let index = 0;
    let sliding = false;
    let startX = null;
    let startY = 0;

    const goSlide = (n) => {
      n = (n + slides.length) % slides.length;
      if (n === index || sliding) return;
      const prev = slides[index];
      const next = slides[n];
      index = n;
      sliding = true;
      q('.ww-dots__dot', dots).forEach((d) => {
        const on = +d.dataset.dot === n;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      const out = q('[data-ww-split]', prev);
      const inn = q('[data-ww-split]', next);
      const finish = () => {
        sliding = false;
      };
      if (!gsap) {
        prev.setAttribute('aria-hidden', 'true');
        next.setAttribute('aria-hidden', 'false');
        finish();
        return;
      }
      [...out, ...inn].forEach((l) => (l.style.transition = 'none'));
      gsap.killTweensOf([...out, ...inn]);
      gsap.to(out, {
        opacity: 0,
        y: -6,
        duration: reduced ? 0.01 : 0.5,
        ease: 'power2.in',
        onComplete: () => prev.setAttribute('aria-hidden', 'true'),
      });
      hide(inn);
      next.setAttribute('aria-hidden', 'false');
      reveal(inn, { delay: reduced ? 0 : 0.6 });
      setTimeout(finish, reduced ? 50 : 1400);
    };

    q('.ww-dots__dot', dots).forEach((d) => d.addEventListener('click', () => goSlide(+d.dataset.dot)));
    slider.addEventListener('pointerdown', (e) => {
      startX = e.clientX;
      startY = e.clientY;
    });
    slider.addEventListener('pointercancel', () => {
      startX = null;
    });
    slider.addEventListener('pointerup', (e) => {
      if (startX == null) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goSlide(index + (dx < 0 ? 1 : -1));
      else if (Math.abs(dx) < 10 && Math.abs(dy) < 10) goSlide(index + 1);
    });
  }

  /* Anchor links glide instead of jumping */

  q('a[href^="#ww-"]:not([data-ww-enter])').forEach((a) =>
    a.addEventListener('click', (e) => {
      const target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const header = document.querySelector('#header');
      const offset = header ? header.offsetHeight : 0;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: reduced ? 'auto' : 'smooth' });
    })
  );

  /* Add to cart without leaving the page */

  const status = root.querySelector('[data-ww-status]');

  const refreshCart = (item) => {
    const Cart = window.Cart;
    if (Cart && typeof Cart.getCart === 'function' && typeof Cart.buildCart === 'function') {
      Cart.getCart(Cart.buildCart);
      if (Cart.popover && typeof Cart.popover.show === 'function' && window.innerWidth >= 550) Cart.popover.show(item);
      return;
    }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
        });
      });
  };

  // Pre-order products: send what the pre-order app adds on the product page, so the order is
  // tagged and held the same way.
  const preorderCampaign = (plan) => {
    try {
      const data = JSON.parse(document.querySelector('essential-preorder-app-embed')?.getAttribute('preorder-app-data') || '{}');
      return (data.preorderCampaigns || []).find((c) => c.sellingPlanIds.includes(+plan));
    } catch (e) {
      return null;
    }
  };

  q('[data-ww-atc]').forEach((btn) =>
    btn.addEventListener('click', () => {
      const id = btn.dataset.variantId;
      if (!id || btn.disabled) return;
      const label = btn.querySelector('[data-ww-atc-label]');
      const original = label.textContent;
      const body = new URLSearchParams({ id, quantity: '1' });
      const plan = btn.dataset.sellingPlan;
      if (plan) {
        body.set('selling_plan', plan);
        const campaign = preorderCampaign(plan);
        if (campaign) {
          const { cartNoteKey, cartNoteText } = campaign.content;
          body.set('properties[_essential_preorder_campaign_id]', campaign.id);
          if (cartNoteKey) {
            body.set(`properties[${cartNoteKey}]`, cartNoteText);
            body.set('properties[_essential_preorder_props]', cartNoteKey);
          }
        }
      }
      btn.disabled = true;
      label.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: body.toString(),
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error(data.description || data.message || 'Could not add to cart');
          label.textContent = 'Added';
          if (status) status.textContent = `${data.product_title || 'Item'} added to cart`;
          refreshCart(data);
        })
        .catch((err) => {
          label.textContent = 'Unavailable';
          if (status) status.textContent = err.message;
        })
        .finally(() => {
          setTimeout(() => {
            label.textContent = original;
            btn.disabled = false;
          }, 2000);
        });
    })
  );
})();
